import { render, staticRenderFns } from "./SortSettings.vue?vue&type=template&id=1251fe9d"
import script from "./SortSettings.vue?vue&type=script&lang=js"
export * from "./SortSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports